import styled from "styled-components";

export default function Divider () {
    return (
        <DividerLine></DividerLine>
    )
}

const DividerLine = styled.div`
  width: 100%;
  height: 2px;
  margin: 24px 0;
  background-color: var(--primary-pistachio);
`;